// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2an25","top":"styles_top__3u2lb","left":"styles_left__Ujvsy","description":"styles_description__1QSEc"};